import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import swal from 'sweetalert2';
import moment from 'moment';
import map from 'lodash/map';

import UserConnexion from '../../components/Connexion';
import UserBusiness from '../../components/Business';
import UserInfo from '../../components/Info';
import UserOptins from '../../components/Optins';
import UserLeaguesInfo from '../../components/LeaguesInfo';
import {copyTextToClipboard} from '../../../../../helpers/utils';
import {
  fetchUserIfNeeded,
  removeUser,
  forceUserPassword,
  fetchPurchases,
  updateUserOptIn,
} from '../../../../../actions/app/support/user';

import './UserInfoWidget.css';
import Loader from '../../../../../components/Loader';
import {
  getUserVersions,
  hideUserLeague,
  updateUser,
} from '../../../../../actions/entities/user';
// import UserMailPush from '../UserMailPush';
// import UserAlerts from '../UserAlerts';

class UserInfoWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      identifier: props.identifier || '',
      leagues: [],
      purchasesList: null,
      fetchMailPush: false,
      fetchAlerts: false,
      userVersions: false,
    };
  }

  fetchUserInfo(e) {
    if (e) e.preventDefault();
    const {identifier} = this.state;
    this.props.dispatch(fetchUserIfNeeded({identifier}));
  }

  removeUser(e) {
    if (e) e.preventDefault();

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      confirmButtonColor: '#d33',
    }).then(() => {
      const {entity} = this.props.user;
      entity &&
        this.props.dispatch(
          removeUser({userId: entity.id, email: entity.email}),
        );
    });
  }

  forceUserPassword(e) {
    if (e) e.preventDefault();

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, force it!',
    }).then(() => {
      const {entity} = this.props.user;
      entity && this.props.dispatch(forceUserPassword({userId: entity.id}));
    });
  }

  displayRequestMessage(info = this.props.widget.info) {
    if (info.success) {
      switch (info.lastAction) {
        case 'REQUEST_REMOVE_USER':
          swal(
            `Success!`,
            `User ${info.lastPayload.email} was removed.`,
            'success',
          );
          break;
        case 'REQUEST_FORCE_USER_PASSWORD':
          swal({
            title: `Success!`,
            text: `New password is: ${info.success}`,
            type: 'success',
            confirmButtonText: '<i class="fa fa-clipboard"></i> Copy it',
            confirmButtonAriaLabel: 'Copy it',
          }).then(function () {
            const success = copyTextToClipboard(info.success);
            success
              ? swal(
                  `Copied!`,
                  `${info.success} is in your clipboard.`,
                  'success',
                )
              : swal(`Oops...`, `We couldn't copy ${info.success}`, 'error');
          });
          break;
        default:
          break;
      }
    } else if (info.error) {
      switch (info.error) {
        case 'userNotFound':
          break;
        default:
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong with: "${info.lastAction}"<br/>` +
              `<pre style="text-align: left"><code>${JSON.stringify(
                info,
                undefined,
                4,
              )}</code></pre>`,
          });
      }
    }
  }

  componentDidMount() {
    const {user} = this.props;
    if (user.entity) {
      const leagues = {};
      map(user.entity.leagues, league => {
        leagues[league.id] = league;
      });

      this.setState({leagues});
    }
    if (this.state.identifier) this.fetchUserInfo();
  }

  componentWillReceiveProps(nextProps) {
    const {info} = this.props.widget;
    const nextInfo = nextProps.widget.info;

    if (info.success !== nextInfo.success || info.error !== nextInfo.error)
      this.displayRequestMessage(nextInfo);

    if (
      nextProps.user.entity &&
      this.props.user.entity !== nextProps.user.entity
    ) {
      this.setState({purchasesList: null});
      const leagues = {};
      map(nextProps.user.entity.leagues, league => {
        leagues[league.id] = league;
      });

      this.setState({leagues});
    }
  }

  renderNoResult() {
    const {info} = this.props.widget;
    const {error} = info;

    return (
      <div className="no-result text-center">
        <h4 className="text-muted">Want to find a particular user ?</h4>
        <form className="form-inline" onSubmit={e => this.fetchUserInfo(e)}>
          <div
            className={classNames('form-group', {
              'has-error': error === 'userNotFound',
            })}>
            <div className="input-group input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Email or userId"
                value={this.state.identifier}
                onChange={e => this.setState({identifier: e.target.value.replace(/\s/g, '')})}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-flat"
                  onClick={this.fetchUserInfo.bind(this)}>
                  <i className="fa fa-search" />
                </button>
              </span>
            </div>
            {error === 'userNotFound' && (
              <span className="help-block">
                We couldn't find {info.lastPayload.email}
              </span>
            )}
          </div>
        </form>
      </div>
    );
  }

  renderLeagues(leagues, userId) {
    if (!leagues || !userId) {
      return false;
    }

    return (
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>League</th>
            <th>Name</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {leagues.map(({id, name}) => (
            <tr key={id}>
              <td>{id.replace('mpg_league_', '')}</td>
              <td>{name}</td>
              <td>
                <input
                  onChange={() => {
                    const l = this.state.leagues[id];

                    const onRequest = () => {
                      this.setState({
                        leagues: {
                          ...this.state.leagues,
                          [id]: {isHiding: true, isHidden: l.isHidden},
                        },
                      });
                    };
                    const onSuccess = () => {
                      this.setState({
                        leagues: {
                          ...this.state.leagues,
                          [id]: {isHiding: false, isHidden: !l.isHidden},
                        },
                      });
                    };
                    const onFail = (type, error) => {
                      swal({
                        title: `Oops...`,
                        type: 'error',
                        html:
                          `Something went wrong with: "${type}"<br/>` +
                          `<pre style="text-align: left"><code>${JSON.stringify(
                            error,
                            undefined,
                            4,
                          )}</code></pre>`,
                      });

                      this.setState({
                        leagues: {
                          ...this.state.leagues,
                          [id]: {isHiding: false},
                        },
                      });
                    };

                    this.props.dispatch(
                      hideUserLeague(
                        {
                          hide: !l.isHidden,
                          leagueId: id,
                          userId,
                        },
                        onSuccess,
                        onFail,
                        onRequest,
                      ),
                    );
                  }}
                  type="checkbox"
                  id={`${id}-isHidden`}
                  name={`${id}-isHidden`}
                  value="isHidden"
                  checked={
                    this.state.leagues[id] && this.state.leagues[id].isHidden
                  }
                  disabled={
                    this.state.leagues[id] && this.state.leagues[id].isHiding
                  }
                />
                &nbsp;
                <label htmlFor={`${id}-isHidden`}>
                  Hidden{' '}
                  {this.state.leagues[id] &&
                    this.state.leagues[id].isHiding && (
                      <i className="fa fa-spinner fa-spin" />
                    )}
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  fetchUserPurchases(userId) {
    const onSuccess = response => {
      this.setState({purchasesList: response.purchases});
    };
    const onError = error => {
      console.log(error);
    };
    this.props.dispatch(fetchPurchases({userId}, onSuccess, onError));
  }

  toggleOptIn(key, value) {
    const {id} = this.props.user.entity;
    const payload = {id, [key]: value === 1 ? 0 : 1};

    this.props.dispatch(updateUserOptIn(payload));
  }

  getActionForKey(key, value) {
    const optIn = ['optin_alert', 'optin_nl', 'optin_partner', 'optin_wall'];
    const whiteList = [...optIn];

    if (!whiteList.includes(key)) return false;

    if (optIn.includes(key)) {
      return (
        <span className="toggle-opt-in">
          <i
            onClick={() => this.toggleOptIn(key, value)}
            className={classNames('fa fa-2x', {
              'fa-toggle-on': value === 1,
              'fa-toggle-off': value !== 1,
            })}
          />
        </span>
      );
    }
  }

  addFeatureToUser(type, id) {
    this.props.dispatch(
      updateUser(
        {id: id, [type]: moment().add(1, 'years').utc().format()},
        null,
        () => this.fetchUserInfo(),
      ),
    );
  }

  onSuccessOptinsInApp = () => {
    this.fetchUserInfo();
  };

  fetchVersions = userId => {
    const onSuccess = response => {
      this.setState({userVersions: response});
    };
    this.props.dispatch(getUserVersions(userId, onSuccess));
  };

  renderBody() {
    const {user} = this.props;
    // const {fetchMailPush, fetchAlerts, userVersions} = this.state;
    const {entity} = user;

    const applicationsData = entity?.applicationsData?.mpg
      ? entity?.applicationsData?.mpg
      : entity?.applicationsData?.mpm;

    // const optinsInApp = ['gameWeek', 'mercato', 'funThings', 'partnerNews'];
    if (!entity) return this.renderNoResult();

    return (
      <div>
        <UserConnexion user={entity} applicationsData={applicationsData} />
        <UserInfo user={entity} applicationsData={applicationsData} />
        <UserBusiness user={entity} applicationsData={applicationsData} />
        <UserOptins user={entity} />
        <UserLeaguesInfo user={entity} />
      </div>
    );
  }

  renderFooter() {
    const {entity} = this.props.user;

    return (
      entity && (
        <div className="box-footer form-inline">
          <div className="pull-left">
            <button
              className="btn btn-danger btn-flat margin-r-5 "
              onClick={e => this.removeUser(e)}>
              <i className="fa fa-trash-o" /> Remove
            </button>
          </div>
          <div className="input-group pull-right">
            <button
              className="btn btn-warning btn-flat margin-r-5 "
              onClick={e => this.forceUserPassword(e)}>
              <i className="fa fa-key" /> Force password
            </button>
            <form onSubmit={e => this.fetchUserInfo(e)} className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Email or userId"
                value={this.state.identifier}
                onChange={e => this.setState({identifier: e.target.value.replace(/\s/g, '')})}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-default btn-flat"
                  onClick={this.fetchUserInfo.bind(this)}>
                  <i className="fa fa-search" />
                </button>
              </span>
            </form>
          </div>
        </div>
      )
    );
  }

  render() {
    const {info} = this.props.widget;

    return (
      <div id="user-info-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-info-circle" /> User info
              </h3>
              <div className="box-tools pull-right">
                <button
                  type="button"
                  className="btn btn-box-tool"
                  data-widget="collapse">
                  <i className="fa fa-minus" />
                </button>
              </div>
            </div>
            <div className="box-body body-fixed">{this.renderBody()}</div>
            {this.renderFooter()}
            {info.isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

UserInfoWidget.propTypes = {
  email: PropTypes.string,
};

export default connect(
  state => {
    const {users} = state.entities;
    const widget = state.app.support.user;
    return {widget, user: {entity: users && users[widget.id]}};
  },
  dispatch => ({dispatch}),
)(UserInfoWidget);



// WEBPACK FOOTER //
// ./src/pages/Support/User/Widgets/UserInfo/index.js